import { render, staticRenderFns } from "./Vineyards.vue?vue&type=template&id=69725557&scoped=true&"
import script from "./Vineyards.vue?vue&type=script&lang=js&"
export * from "./Vineyards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69725557",
  null
  
)

export default component.exports